import type { Partner } from "@core/schema/Partner.js";
import type { PartnerPlacement } from "@core/schema/PartnerPlacement.js";

export function getPartnerLogos(partners: Partner[], partnerPlacement: PartnerPlacement): Partner[][] {
	const filteredPartners = partners.filter((partner) => partner.placements.includes(partnerPlacement));

	const middleIndex = Math.ceil(filteredPartners.length / 2);
	const firstHalf = filteredPartners.slice(0, middleIndex);
	const secondHalf = filteredPartners.slice(middleIndex);

	return [firstHalf, secondHalf];
}
